import { inherits as _inherits, createClass as _createClass, superPropGet as _superPropGet, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { enums } from '@optimizely/react-sdk';
import { BaseLogHandler } from './baseLogHandler.js';
import { httpConstants } from '../../constants.js';
import config from '../../config.js';
import { http } from '../../http.js';
import { getAppName, getLogLevelStr } from '../../utils.js';

var ServerLogHandler = /*#__PURE__*/function (_BaseLogHandler) {
  function ServerLogHandler() {
    _classCallCheck(this, ServerLogHandler);
    return _callSuper(this, ServerLogHandler, arguments);
  }
  _inherits(ServerLogHandler, _BaseLogHandler);
  return _createClass(ServerLogHandler, [{
    key: "handle",
    value: function handle(logLevel, message) {
      if (logLevel === enums.LOG_LEVEL.ERROR) {
        // splunk logging will done only for the logLevel - ERROR
        var url = window.origin + config.endPoints.logging;
        http.httpRequest(url, {
          appName: getAppName(),
          logLevel: getLogLevelStr(logLevel),
          message: message
        }, httpConstants.HTTP_METHODS.POST, httpConstants.HTTP_REQ_DEFAULT_HEADERS);
      }
      _superPropGet(ServerLogHandler, "handle", this, 3)([logLevel, message]);
    }
  }]);
}(BaseLogHandler);
var serverLogHandler = new ServerLogHandler();

export { serverLogHandler as default };
